<ng-container *ngIf="visible">
  <div class="lv-backdrop" (click)="close()"></div>

  <div class="lv-panel" role="dialog" aria-label="Log Viewer">
    <!-- Header -->
    <div class="lv-header">
      <div class="lv-title">
        <span class="lv-icon">⬡</span>
        <span>LOGS</span>
        <span class="lv-count">{{ filteredLogs.length }}</span>
      </div>
      <div class="lv-actions">
        <button class="lv-btn lv-btn--ghost" (click)="export()" title="Exporter">↓</button>
        <button class="lv-btn lv-btn--ghost" (click)="clear()" title="Vider">✕ clear</button>
        <button class="lv-btn lv-btn--close" (click)="close()">✕</button>
      </div>
    </div>

    <!-- Filters -->
    <div class="lv-filters">
      <div class="lv-level-tabs">
        <button
          *ngFor="let lvl of levels"
          class="lv-tab"
          [class.lv-tab--active]="filter === lvl"
          [attr.data-level]="lvl"
          (click)="setFilter(lvl)"
        >{{ lvl }}</button>
      </div>
      <input
        class="lv-search"
        type="text"
        placeholder="Rechercher…"
        [(ngModel)]="search"
        (ngModelChange)="onSearchChange()"
      />
    </div>

    <!-- Log list -->
    <div class="lv-body">
      <div
        *ngFor="let entry of filteredLogs; trackBy: trackByIndex"
        class="lv-entry"
        [attr.data-level]="entry.level"
      >
        <span class="lv-entry-time">{{ formatTime(entry.time) }}</span>
        <span class="lv-entry-badge">{{ entry.level }}</span>
        <span class="lv-entry-msg">{{ entry.message }}</span>
        <span *ngIf="entry.context" class="lv-entry-ctx">{{ entry.context | json }}</span>
      </div>

      <div *ngIf="filteredLogs.length === 0" class="lv-empty">
        Aucun log trouvé
      </div>
    </div>
  </div>
</ng-container>